import httpStore from "@/api/httpStore.js";

export function generateSitemap() {
  return httpStore
    .get(`/sitemap/generate`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
